module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Terminplan.682a4cd4.svg";